import {useState, useEffect, useMemo} from "react";

const DEFAULT_SPEED_MS = 50;

type UseTypingEffectOptions = {
  speedMs?: number;
};

const getGraphemes = (text: string): string[] => {
  if (typeof Intl.Segmenter === "undefined") {
    return [...text];
  }
  const segmenter = new Intl.Segmenter("ko", {granularity: "grapheme"});
  return Array.from(segmenter.segment(text)).map((s) => s.segment);
};

export const useTypingEffect = (
  fullText: string,
  options?: UseTypingEffectOptions
): string => {
  const speedMs = options?.speedMs ?? DEFAULT_SPEED_MS;
  const graphemes = useMemo(() => getGraphemes(fullText), [fullText]);
  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    setDisplayedText("");
    if (graphemes.length === 0) {
      return;
    }
    let index = 0;
    const id = setInterval(() => {
      if (index < graphemes.length) {
        index += 1;
        setDisplayedText(graphemes.slice(0, index).join(""));
      }
      if (index >= graphemes.length) {
        clearInterval(id);
      }
    }, speedMs);
    return () => clearInterval(id);
  }, [fullText, graphemes, speedMs]);

  return displayedText;
};
